import { makeStyles } from '@material-ui/core/styles';

import { neutral, orange, red } from 'shared/styles/colors';
import { MOZART_COMPLAINT_REASON } from 'features/mozart-notifications/domain';

export default makeStyles({
  alert: {
    marginTop: '-0.5rem',
    padding: '1rem',
    color: orange[70],
    backgroundColor: orange[10],
    '& > header': {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      color: orange[70],
      '& > [aria-label="title"]': {
        fontWeight: 600,
        fontSize: '0.875rem',
        lineHeight: '1.5rem',
      },
    },
    '&[aria-label="description"]': {
      fontSize: '0.875rem',
      lineHeight: '1.5rem',
      color: orange[70],
    },
    [`&[data-complaint-reason="${MOZART_COMPLAINT_REASON.DEFECT_GROUNDED}"]`]: {
      color: neutral.white,
      backgroundColor: red[60],
      '& > *': {
        color: neutral.white,
      },
    },
  },
});
